import { render, staticRenderFns } from "./feature.vue?vue&type=template&id=1bf99acb&scoped=true"
import script from "./feature.vue?vue&type=script&lang=js"
export * from "./feature.vue?vue&type=script&lang=js"
import style0 from "./feature.vue?vue&type=style&index=0&id=1bf99acb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf99acb",
  null
  
)

export default component.exports